import { EX8057 } from 'config/flags';

export const showWalkthroughKey = (user: any) => {
    if (!user) return false;
    return EX8057 ? !user?.is_walkthrough_completed : user?.show_walkthrough_free_trial;
};
